import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap"

const ErrorMessage = ({ message } : {message: string}) => {
  // document.title = "Error Occur| Content Bow"
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10); // Set initial countdown value here

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prevCountdown => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
      clearInterval(timer);
      navigate('/login');
    }

    return () => clearInterval(timer);
  }, [countdown, navigate]);

  return (
    <div className=" my-5 pt-5">
      <Container>
        <Row>
          <Col lg="12">
            <div className="text-center mb-5">
              <h1 className="display-2 fw-medium">
                4<i className="bx bx-buoy bx-spin text-primary display-3" />
                3
              </h1>
              <h4 className="text-uppercase">{message}</h4>
              <p className="mb-0 mt-3 text-muted">We are unable to verify your credentials.</p>
              <p className="mt-0 text-muted">Please login again to continue.</p>
              <div className="text-center">
                <Link to="/login" className="btn btn-primary mt-4 mb-2">
                  Login
                </Link>
                <p>Redirecting in {countdown} seconds...</p>
              </div>
            </div>
          </Col>
        </Row>
        {/* <Row className="justify-content-center">
          <Col md="8" xl="6">
            <div>
              <img src={error} alt="Error" className="img-fluid" />
            </div>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default ErrorMessage;